<template>
  <div>
    <div
      style="
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 999;
        background-color: #ffffff;
      "
    >
      <div
        style="
          margin: 0 auto;
          padding: 0 20px;
          width: 1200px;
          height: 80px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <el-image
          :src="require('@/assets/logo.png')"
          style="width: 272px; height: 55px"
        ></el-image>
        <div
          style="
            margin-left: 180px;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            background-color: #ffffff;
            /* '#27cbee' */
          "
        >
          <div :class="['menu-item']" @click="$router.go(-1)">返回首页</div>
        </div>
      </div>
    </div>
    <el-carousel style="margin-top: 80px; width: 100%" height="460px">
      <el-carousel-item v-for="item in imageList" :key="item">
        <el-image :src="item"></el-image>
      </el-carousel-item>
    </el-carousel>
    <div
      style="
        padding: 10px 0;
        background-color: rgb(238, 238, 238);
        text-align: center;
      "
    >
      <el-breadcrumb
        style="
          margin: 0 auto;
          width: 1200px;
          font-size: 12px;
          line-height: 14px;
          color: #434a54;
        "
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <!-- <el-breadcrumb-item :to="{ path: '/' }">{{ title }}</el-breadcrumb-item> -->
        <el-breadcrumb-item>{{ subTitle }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div
      v-if="id == 1 && type == 1"
      style="padding: 20px 0; width: 1200px; margin: 0 auto"
    >
      <div
        style="
          margin-top: 40px;
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          line-height: 34px;
        "
      >
        {{ "新零售时代来临 医药行业发展趋势" }}
      </div>
      <div
        style="
          margin: 20px auto;
          width: 300px;
          font-size: 12px;
          color: #999;
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <span>{{ "2021-05-25" }}</span>
        <div style="display: flex; align-items: baseline">
          <i class="el-icon-view"></i>
          <span>{{ "2517" }}</span>
        </div>
      </div>
      <p>
        2017年中医药电商基础服务体系会更加完善。电商平台建立、移动互联网成熟、配送等服务体系不断完善，医药电商将成为新兴购药渠道。先进物流设备及管理软件、手段也将被不断地应用于医药物流产业中。
      </p>
      <h3>新零售时代来临</h3>
      <p>
        自1992年小平同志南巡讲话后，我国改革开放程度加深，经济开始迅速繁荣发展。自1992年至今，我国经济发展可分为三个阶段：
      </p>
      <h3>1992年-2002年：暴利时代</h3>
      <p>
        1992年后中国开始转入市场经济阶段。突如其来的经济转型使中国社会物质产品大爆发，伴随着利润和财富的爆发，中国马上进入了暴利时代。需求远远大于生产，这个阶段的经济特征是“以产定销”。市场的活力得到很大程度的释放，人们的生活改善了很多。这是一个小批发、小零售的阶段，一直持续到2002年。
      </p>
      <h3>2003年-2012年：薄利时代</h3>
      <p>
        从2003年开始，中国经济开始进入大批发、大零售的阶段，也可以说是“以销定产”。在市场需求的刺激之下，商品的品类越来越丰富，于是有的商品就形成了“品牌”，这种品牌是野蛮生长下的产物，是被动出现的，而不是主动开创出来的。
      </p>
      <p>
        与此同时，电商模式出现并越来越深刻地改变着我们的生活，这也促使商业进入了到了下一个阶段：薄利时代。电商把利润环节压缩了，商业竞争变成了赤裸裸的价格战。
      </p>
      <p>
        人工不断上涨，利润越来越低，商家越来越无利可图，只有偷工减料、山寨造假。所以各种假货、三聚氰胺以及地沟油等在这个阶段爆发出现。更重要的是，电商彻底打乱了原来的大批发产业链，由于电商压缩了产业链，很多人被排挤淘汰，于是社会的消费能力就开始下降。
      </p>
      <h3>2013年-2017年：动荡时代</h3>
      <p>这五年时间，是中国商业的“纠结”阶段。</p>
      <p>
        首先，传统实业不断倒闭，大家都很迷茫。而电商在消灭了许多环节之后，自己也开始渐入困境，大家都低价，已经无利可图。与此同时，产能过剩出现，实业倒闭的速度加快，随着消费能力的下降，加上需要承担库存，经销商订货速度也慢了，所以这五年我们拼命叫喊新概念，比如互联网思维、O2O、互联网+等等，似乎只有这些新概念可以应对库存问题。这就是混沌动荡的商业状态，这种纠结将一直持续到2016年。
        所谓物极必反，有盛极而衰，就会有否极泰来，经济也是如此。2016年是大破之年，2017年则会是大立之年。
      </p>
      <p>
        2016年11月11日，国务院办公厅颁发了一个针对零售业的文件——《国务院办公厅关于推动实体零售创新转型的意见》。其明确指出：实体零售是商品流通的重要基础，是引导生产、扩大消费的重要载体，是繁荣市场、保障就业的重要渠道。我国实体……暴露出发展方式粗放、有效供给不足、运行效率不高等突出问题。当前，受经营成本不断上涨、消费需求结构调整、网络零售快速发展等诸多因素影响，实体零售发展面临前所未有的挑战……这份文件是和电商双11同一天出台，代表着国家对电商和实体的同等重视。
      </p>
      <p>
        2017年会是中国下一个商业元年。其实商业的本质很简单，就是为客户提供独有价值的服务或产品，同时实现自己的收益。收益的多少取决于提供价值的大小，商业正在越来越接近这个逻辑。
      </p>
      <h3>新零售时期医药行业发展趋势</h3>
      <p>我们从零售角度来分析一下医药行业的发展趋势。</p>
      <p>
        1、医改政策逐步落地，行业发展日趋规范。2016年是我国医药政策红利之年，医改政策频出，剑指医药行业症结所在。一致性评价、两票制、审批审评制度改革等等，无疑都将对医药行业的发展产生深远影响，2017年将是这些改革政策落地、效果渐显的一年，也将是医药行业承上启下的重要一年。两票制将在全国范围内推广、一致性评价开始快速推进、审批审评将加速解决目前积压严重的问题等，相关企业只有顺应政策导向，规范化经营才能获得发展。
      </p>
      <p>
        2、中医药发展，品牌化厚利。真正的品牌需要大量的文化积淀，需要自己的原创基因，品牌本身就是信誉和质量的保证，同时具有传承价值。伴随着国家的经济达到一定程度，其文化输出是必然的，文化输出又是附着在一定的产品上。2016年我国颁布《中国人民共和国中医药法》，从法律层面上保障中医药的传承与发展，2017年将是我国中医药规范化、科学化发展的黄金时期。传统文化复兴，中医被认可，中国文化正在积聚能量，影响到商业上就是我们的产品将有提升附加值的机会了。不仅是中医药，医药零售药店也将日趋品牌化，连锁经营、兼并的趋势将会更加明显。对实体店来说，一个扩大销量的办法就是增加体验，对医药零售来说，这就从买卖关系升级成为一种服务关系，也是一种提升产品附加值的表现。
      </p>
      <p>
        3、医药市场化，消费精准化。2016年末，央视关于医生回扣问题的调查曝光引起了不小的反响，随着新一年我国医改的不断推进，医药分家的趋势也将不断深化，医生的行为会更加规范，因此医药代表将会逐渐淡出。随着医药分家，处方药外流，药品作为商品的一种其市场化性质将会更加明显。对于医药零售而言，未来市场的需求会越来越多元化、个性化，也会越碎片化，要想找到市场，一定要通过大数据和云计算去匹配，因此数据分析与预测将显得尤为重要。
        4、医药电商稳健发展。我国老龄化趋势日益加深，慢性病患者众多，医药产品需求量大。数据表示，越来越多的消费者开始接受互联网购买药品和医疗器械，更多的医药企业进入互联网市场，整体推动市场规模增长。
        经过几年的探索，我们发现互联网+实业是走不通的，因为互联网没有创造实际价值，颠倒主次只能造就虚拟经济的泡沫。所以要让实业去+互联网，互联网的作用是提供一个资源共享的平台。
      </p>
      <p>
        因此，2017年中医药电商基础服务体系会更加完善。电商平台建立、移动互联网成熟、配送等服务体系不断完善，医药电商将成为新兴购药渠道。先进物流设备及管理软件、手段也将被不断地应用于医药物流产业中。
        预计未来自营B2C企业中将会出现领先企业，领先企业具备多样化产品服务模式，将发展重心从售药逐渐转移到用户定制化服务上，依靠提供健康解决方案进行供应链整合，实施差异化战略，不断完善移动端医药布局，创新盈利模式逐渐清晰。
        当然，医药电商发展也需要进一步完善监管法规体系，从根本上立法规范互联网药品、医疗器械、服务监管，完善行政法规，让监管有法可依。探索机器识别非法售药信息，探索利用互联网技术对药品违法信息实行实时关闭等先进技术。
      </p>
    </div>
    <div
      v-if="id == 2 && type == 1"
      style="padding: 20px 0; width: 1200px; margin: 0 auto"
    >
      <div
        style="
          margin-top: 40px;
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          line-height: 34px;
        "
      >
        {{ "连锁药店市场再遇瓶颈 医药电商成为连锁药店救命稻草" }}
      </div>
      <div
        style="
          margin: 20px auto;
          width: 300px;
          font-size: 12px;
          color: #999;
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <span>{{ "2021-05-25" }}</span>
        <div style="display: flex; align-items: baseline">
          <i class="el-icon-view"></i>
          <span>{{ "2506" }}</span>
        </div>
      </div>
      <p>
        随着“药价放开”政策的执行，药品价格由市场自由竞争来决定，大量消费者可以选择在院外购药，这对药店来说是利好的。连锁药店也如雨后春笋般的涌现，但是市场是有限的。在中国药店的数量已经过多，连锁药店面临着种种生存危机，在移动互联网的大平台下，连锁药店纷纷试水医药O2O模式。
      </p>
      <h3>连锁药店线上线下齐增长</h3>
      <p>
        截至2014年12月底，全国连锁门店数为171431家，相比2013年，连锁门店则增加13187家，同比增长8.3%。
        全国网上药店有288家，而在2013年3月12日，这个数字仅为162家。全国网上药店增加了126家，同比增长77%。
        药品零售行业的连锁率达到39.42%，2013年这个数据为36.57%，同比增长2.85%。
        连锁门店 8.3%，网上药店 77%，药品零售连锁率 2.85%。
      </p>
      <h3>线下连锁药店难以突围</h3>
      <p>
        连锁药店竞争手段单一，产品竞争、服务竞争、规模竞争只是少数连锁药店的竞争策略，而低成本竞争则是常态化、长期化的。
        连锁药店的服务意识不强，连锁药店总是一再地强调并且自认为很重视服务，但服务始终是放在从属于产品的位置上。
        连锁药店对于服务营销的理念理解不够，绝大多数连锁药店经营的指导思想主要还是放在产品上。
        连锁药店对于服务质量和服务的规范化缺乏控制，引起消费者对连锁药店的不满情绪，而最终导致连锁药店的形象受损。
        在药品营销中，有形展示基本上就是药品本身，若不善于管理和运用，则它们可能会传达错误的信息给顾客，影响顾客对产品的期望和判断。
        国家对从事药品购销业务的人员有相关要求，需要获取医药商品购销员职业资格证书方可从事相关工作，可大部分地区对从业人员没有强制要求。
      </p>
      <h3>线上网上药店限制重重</h3>
      <h4>“不能报销”让消费者难享低价实惠</h4>
      <p>
        不能与“医疗保险”、“新农合”等一系列医疗保障体系对接，把绝大多数享受医保等福利政策的消费者挡在了网上药店的大门之外。
      </p>
      <h4>“门店送货”让网上药店左右为难</h4>
      <p>
        根据我国药品法的相关规定，药品作为关系人们生命安全的特殊商品，是不允许邮购的。然而地域分割是中国药品市场的基本特征。一边是地域性明显、数量有限的实体门店，一边是没有空间限制的网上订单，如何协调两者差异而又不违反国家的法律法规，成为摆在所有网上药店老总面前的一道难题。
      </p>
      <h4>“不卖处方药”让网上药店痛失最大蛋糕</h4>
      <p>
        我国食品药监局规定，“医疗机构不得采用邮售、互联网交易、柜台开架自选等方式直接向公众销售处方药”，向个人消费者提供互联网药品交易的企业只能在网上销售本企业经营的非处方药。
      </p>
      <h3>连锁药店发展八大趋势</h3>
      <h4>1、奶粉、中药、大健康品类引领增长</h4>
      <p>
        治疗性药品品类在药店的销售持续下降，使得营业额和毛利总额增长面临巨大压力。缓解的唯一方法就是：增加大健康非药品类。
      </p>
      <h4>2、国医馆带旺中药销售</h4>
      <p>
        现在不少药店是西药为主，但是中医药的治病效果不容抹杀与忽视，必须重视中药销售。想做好中药销售的连锁药店，开设中医馆是重要的途径。
      </p>
      <h4>3、精细化管理成趋势</h4>
      <p>
        在各大连锁都开始做会员、品类管理、单品突破的时候，比拼的只有两条：一是差异化，二是精细化。
      </p>
      <h4>4、专业化管理提升</h4>
      <p>
        专业永远是药店的核心价值。以治疗、保健、康复为核心的药学服务，永远是连锁药店的核心竞争力。
      </p>
      <h4>5、营销与会员管理商务电子化</h4>
      <p>
        互联网对于众商家来说，并不需要太焦虑。因为那仅仅是技术，这个技术特别的地方是因为它改变了所有人的生活方式，只要你能基于消费者的需求去做创新，相信你还是可以活得很好。
      </p>
      <h4>6、品类回归品牌是共识</h4>
      <p>
        药品品类回归品牌和价值是连锁药店行业早已有的呼声，是行业共识。回归的原因很简单：品牌是不可代替的，品牌企业的服务也是无可替代的，品牌溢价是营销规律。
      </p>
      <h4>7、联合、联盟、借力更普遍</h4>
      <p>
        各种联盟越来越深入化，这是竞争的需要，联合采购各地都有耳闻。上市连锁药店越来越多时，并购加速就成为必然。
      </p>
      <h4>8、单品突破是必然</h4>
      <p>
        在高毛产品越来越多、产品品类日益增多的环境下，选择“单品突破”既是连锁药店白热化竞争使然，也是提升营业额和毛利总额的需要。
      </p>
      <p>
        结语：在互联网的催化下，中国大型连锁药店已经加速步入药店2.0时代。中国大型药店已经开始由单纯的药品零售商向平台型服务商转变，一切都以用户需求为中心，以线下门店为基础，以互联网为手段，不断增加产品、服务、检验等，打造全新O2O医疗生态。
      </p>
    </div>
    <div
      v-if="id == 3 && type == 1"
      style="padding: 20px 0; width: 1200px; margin: 0 auto"
    >
      <div
        style="
          margin-top: 40px;
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          line-height: 34px;
        "
      >
        {{ "全国统一医保平台上线 影响39万药店" }}
      </div>
      <div
        style="
          margin: 20px auto;
          width: 300px;
          font-size: 12px;
          color: #999;
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <span>{{ "2021-05-25" }}</span>
        <div style="display: flex; align-items: baseline">
          <i class="el-icon-view"></i>
          <span>{{ "2372" }}</span>
        </div>
      </div>
      <p>国家医保信息平台要来了，至少39万家定点药店受益！</p>
      <h3>河北石家庄，上线国家医保信息平台</h3>
      <p>
        近日，河北石家庄市发布《关于国家统一医疗保障信息平台系统试运行公告》（以下简称“公告”）。
        公告显示，石家庄市已完成国家统一医疗保障信息平台系统基本功能的建设和测试，进入试运行阶段。另外，从5月21日8时起，定点药店、定点医疗机构可开通城镇职工、城乡居民门诊购药、住院结算业务(定点药店特药“双通道”购药业务除外)。同时，公告还强调以下4点：
      </p>
      <p>
        1、目前，市医疗保障局仍在密切配合省医疗保障局系统开发团队，对该系统进行优化和完善，如果参保人员在我市就医结算过程中遇到问题，可向所在定点药店、定点医疗机构进行反映。
      </p>
      <p>
        2、因参保人存在省内多条参保信息、社会保障卡损坏或异常等原因导致无法结算的，可向本人参保地经办机构反映核实确认相关信息，或网上登录国家统一医疗保障信息平台进行处理。
      </p>
      <p>
        3、系统切换期间导致无法办理网上异地备案的，视同为已备案。对因系统切换在就医地医疗机构完成现金结算的，参保人回医保经办机构进行现金报销。
      </p>
      <p>
        4、对未办理异地就医备案，但参保人已与就医地医疗机构协商一致可以进行医保出院结算的，参保人可通过“河北省医疗保障局”微信公众号进行补备案，将备案起始时间提前至住院当日或住院当日的前一天。
      </p>
      <p>
        最后公告提醒，由于平台目前为试运行，可能存在就医结算时间延迟等情况，建议市民按照疫情防控要求，错峰办理医保结算等业务。
      </p>
      <h3>各地动作不断，加速布局</h3>
      <p>
        据了解，除了石家庄，河北秦皇岛、廊坊、新乐等地近期也上线了国家医保信息平台，放眼全国，相关动作也是接连不断，据不完全统计：
      </p>
      <p>
        5月20日，广东佛山市正式切换上线国家医保信息平台，惠及596.4万参保人员。
      </p>
      <p>
        5月20日，山东滨州市医保局召开市级医保信息平台上线动员会，会议明确，严格按照省局要求，新医保信息平台必须在100天内上线。
      </p>
      <p>
        5月17日，湖南常德启动全国统一医保信息平台上线工作，是湖南率先上线全国统一医疗保障信息平台的城市之一，涉及全市4000多家定点医药机构。
      </p>
      <p>
        5月13日，贵州省召开省新医保信息平台全面推广启动暨培训会，确保8月底前国家医保信息平台在贵州省全面推广上线。
      </p>
      <h3>国家医保信息平台，年底覆盖全国</h3>
      <p>
        目前，不少地区部门就“医保信息平台建设”问题正紧锣密鼓的筹划，其实早在此前，就已经有地区率先完成。
        据青海日报报道，今年4月20日，国家医保信息平台在青海省全面上线运行。青海省成为全国首个实现医保信息平台业务功能全层级完整上线，而且全省全覆盖。
        据悉，该平台覆盖青海省3360家医保定点药店、医疗机构，为全省563.26万参保人员提供便捷、高效的医保服务，比如在青海海东市，市民需要5天完成的医保经办工作，在平台上操作只需5分钟，相当快捷。
        国家医保局副局长施子海曾谈到，今年10月，国家医保信息平台项目主体将建设完成，目前各地积极推进医保信息平台建设，预计2021年底在全国范围内投入使用。
        其实，借全国医保信息平台“诞生”的医保电子凭证早就基本覆盖全国了。新华社消息称，截止2020年11月，医保电子凭证已普及至全国29省份的医院、药店，接入定点医疗机构超2.6万家，定点药店超过7万家。
      </p>
      <h3>医保业务效率提升，至少39万药店受益</h3>
      <p>
        国家医保信息平台，主要实现城镇职工、城镇居民、农村居民的三保整合，破解各地医保业务标准不统一、数据不互通等问题，提升医疗机构、药店、老百姓的医保业务经办效率等。
        据国家医保局相关人士介绍，截至2020年底，全国定点医疗药店大概39万家。也就是说，年底医保信息平台全国地区都上线后，上述药店将从中收益。
        国家医保信息平台，不光能提高医药机构、消费者的医保业务经办效率，也能扩大居民医保卡的使用地区，尤其是跨省。
        5月6日，国家医保局、财政部联合发布《关于加快推进门诊费用跨省直接结算工作的通知》强调，要全力推进定点医药机构联网工作，2021年9月底前，全国所有统筹地区依托国家医保信息平台提供统一的线上备案服务。这也就意味着，消费者将来看病买药可以跨省刷医保卡，都必须通过国家医保信息平台实现，这对药店来说是个利好。
      </p>
    </div>
    <div
      v-if="id == 1 && type == 2"
      style="padding: 20px 0; width: 1200px; margin: 0 auto; text-align: center"
    >
      <div
        style="
          margin-top: 40px;
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          line-height: 34px;
        "
      >
        {{
          "门店功能分区，店面升级改造即，我们将以更好的服务环境和精神面貌为您服务"
        }}
      </div>
      <div
        style="
          margin: 20px auto;
          width: 300px;
          font-size: 12px;
          color: #999;
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <span>{{ "2021-05-25" }}</span>
        <div style="display: flex; align-items: baseline">
          <i class="el-icon-view"></i>
          <span>{{ "423" }}</span>
        </div>
      </div>
      <p>
        正心大药房，从2003年10月建店至今，已经陪伴大家18年之久，风霜雕刻，时过境迁，现在的我们也已经被时光剥去了初见的光鲜亮丽，剩下斑驳的墙衣与朦胧的玻璃镌刻下我们一起走过的痕迹，而我们的初心，却一直没变。保证产品品质，满足客户需求提供卓越服务，是我们一路走来陪伴我们的座右铭，十八年的风雨里程,见证着正心大药房的成长、进步与发展，在过去的十八年中，我们以优质的品种，规范的经营，热情的服务在广大的消费者中赢得了口碑，收获了友谊。
      </p>
      <el-image
        :src="require('@/assets/news-1.jpeg')"
        style="width: 553px; height: 248px"
      />
      <p>
        为了向大家提供一个更加方便快捷、舒适温馨的购药环境，我们所有门店即将开启店面功能分区升级改造工作，目前正在筹划中。
      </p>
      <p>
        不管天气如何如何炎热，我们将以更加热情周到的态度竭诚为您服务。我们，将在这里，期待您的光临，竭诚为您服务。
      </p>
    </div>
    <div
      v-if="id == 2 && type == 2"
      style="padding: 20px 0; width: 1200px; margin: 0 auto; text-align: center"
    >
      <div
        style="
          margin-top: 40px;
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          line-height: 34px;
        "
      >
        {{ "春暖花开养生季 正心优嘉送礼来" }}
      </div>
      <div
        style="
          margin: 20px auto;
          width: 300px;
          font-size: 12px;
          color: #999;
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <span>{{ "2021-05-25" }}</span>
        <div style="display: flex; align-items: baseline">
          <i class="el-icon-view"></i>
          <span>{{ "193" }}</span>
        </div>
      </div>
      <p>正心大药房正心币日随心购万元现金大放送。</p>
      <div style="display: flex; align-items: center; flex-direction: column">
        <el-image
          :src="require('@/assets/news-2.png')"
          style="width: 490px; height: 546px"
        />
        <el-image
          :src="require('@/assets/qrcode-1.jpeg')"
          style="width: 368px; height: 399px"
        />
        <el-image
          :src="require('@/assets/activity-1.jpeg')"
          style="width: 347px; height: 925px"
        />
      </div>
    </div>
    <div
      v-if="id == 3 && type == 2"
      style="padding: 20px 0; width: 1200px; margin: 0 auto; text-align: center"
    >
      <div
        style="
          margin-top: 40px;
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          line-height: 34px;
        "
      >
        {{ "正心大药房【宝平店】即将盛大开业！" }}
      </div>
      <div
        style="
          margin: 20px auto;
          width: 300px;
          font-size: 12px;
          color: #999;
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <span>{{ "2021-05-25" }}</span>
        <div style="display: flex; align-items: baseline">
          <i class="el-icon-view"></i>
          <span>{{ "517" }}</span>
        </div>
      </div>
      <p>正心大药房宝平店即将盛大开业，届时豪礼相送，不止五折，敬请期待!</p>
      <div style="display: flex; align-items: center; flex-direction: column">
        <el-image
          :src="require('@/assets/news-3.jpeg')"
          style="width: 553px; height: 276px"
        />
        <h3>门店风采先睹为快</h3>
        <el-image
          :src="require('@/assets/store-1.jpeg')"
          style="margin-bottom: 20px; width: 553px; height: 415px"
        />
        <el-image
          :src="require('@/assets/store-2.jpeg')"
          style="margin-bottom: 20px; width: 553px; height: 647px"
        />
        <el-image
          :src="require('@/assets/store-3.jpeg')"
          style="margin-bottom: 20px; width: 553px; height: 729px"
        />
      </div>
      <p>地址：天津市宝坻区宝平街道鸣石苑西门南50米</p>
      <p>电话：022-29685819</p>
    </div>
    <div
      v-if="id == 4 && type == 2"
      style="padding: 20px 0; width: 1200px; margin: 0 auto; text-align: center"
    >
      <div
        style="
          margin-top: 40px;
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          line-height: 34px;
        "
      >
        {{ "杏林仁心 宝坻名医--------孙秀兰，坐诊正心大药房" }}
      </div>
      <div
        style="
          margin: 20px auto;
          width: 300px;
          font-size: 12px;
          color: #999;
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <span>{{ "2021-05-25" }}</span>
        <div style="display: flex; align-items: baseline">
          <i class="el-icon-view"></i>
          <span>{{ "1141" }}</span>
        </div>
      </div>
      <p>
        通药性，精医理，医药兼修，辩证调方，注康养，治未病，着手成春，悬壶济人，您身边的杏林仁心，宝坻名医孙秀兰。
      </p>
      <div style="display: flex; align-items: center; flex-direction: column">
        <el-image
          :src="require('@/assets/doctor-1.png')"
          style="width: 536px; height: 307px"
        />
        <p>
          1975年孙秀兰主任，毕业于首批中央与地方共建的唐山煤矿医学院中医专业，时至今日在中医临床一线工作，已经近50年，18000多个日夜，孙秀兰主任在运用中医辩证理论，针对黄帝内经中指出“上医治未病，中医治欲病，下医治已病”的中医思想，通过丰富的临床经验积累逐步形成了独到的“注康养、治未病”的医疗理念。
        </p>
        <el-image
          :src="require('@/assets/doctor-2.png')"
          style="margin-bottom: 20px; width: 536px; height: 307px"
        />
        <p>
          孙秀兰主任通过治未病的医疗理念，运用中医理论，辩证治疗各种疑难杂症，对高血压、糖尿病、冠心病、脑梗塞及后遗症等，特别是通过中医银针，针灸治疗对于由述疾病引起的头痛、失眠、中风偏瘫、面瘫、颈腰椎痛等各种疼痛有特别的疗效。
        </p>
        <el-image
          :src="require('@/assets/doctor-3.png')"
          style="margin-bottom: 20px; width: 536px; height: 307px"
        />
        <p>
          孙秀兰主任为了能更多、更好解决病人的病痛，先后到中医药大学附属医院、中国中医研究院进修学习，期间心系家乡的患者，学习结束婉拒了北京西苑医院的任职请求，回到宝坻家乡，就职于人民医院，在康复科任职主任，服务于家乡的人民。
        </p>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 40px;
        "
      >
        <el-image
          :src="require('@/assets/news-4.png')"
          style="width: 190px; height: 190px"
        />
        <div style="margin-left: 20px; text-align: left">
          <div>坐诊时间：每日上午</div>
          <div>坐诊地址：正心大药房总店（老妇幼东200米）</div>
          <div>预约电话：022-29239913</div>
        </div>
      </div>
    </div>
    <div
      v-if="id == 1 && type == 3"
      style="padding: 20px 0; width: 1200px; margin: 0 auto"
    >
      <div
        style="
          margin-top: 40px;
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          line-height: 34px;
        "
      >
        {{ `人人都说保护心脏，多数人却不知道心脏最"怕"你干这些事` }}
      </div>
      <div
        style="
          margin: 20px auto;
          width: 300px;
          font-size: 12px;
          color: #999;
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <span>{{ "2021-05-25" }}</span>
        <div style="display: flex; align-items: baseline">
          <i class="el-icon-view"></i>
          <span>{{ "2074" }}</span>
        </div>
      </div>
      <p>
        常听说胃癌、肝癌、肺癌、肾癌，而心脏，作为维持生命最不可缺少的器官之一，很多人都没有听说过“心脏癌”，这是为什么呢？心脏真的不会长肿瘤吗？
      </p>
      <h2 style="color: #3158ba">1、心脏，并不是“免癌区”</h2>
      <p>
        心脏肿瘤虽然罕见，但还是存在的。心脏中不仅包含肌肉，还有很大一部分是血管，<span
          style="color: #ab1942"
          >这些肌肉和血管都可能长出恶性肿瘤</span
        >。
      </p>
      <p>
        心脏肿瘤主要有两种类型：一类是心脏原发性肿瘤；另一类是其它器官扩散至心脏的继发性肿瘤。
      </p>
      <h3>1、原发性心脏肿瘤</h3>
      <p>
        研究调查显示原发性心脏肿瘤的发病率可低至0.0017%。 换句话说，<span
          style="color: #ab1942"
          >每10万人之中，有那么一两个人会有患心脏肿瘤的可能，非常罕见</span
        >。
      </p>
      <p>
        而这些人中，75%左右为良性，恶性肿瘤只占25%左右。最常见的是以下三种：
      </p>
      <h4>①心脏粘液瘤：良性</h4>
      <p>
        发生率约占全部心脏肿瘤的一半，多为良性。通常发生在心房，但它可以在心腔之间移动，也可能损伤周围组织。
        如果病变严重，不及时进行手术，将会扩展到整个心腔，并阻塞血流，引起中风、血凝块甚至心梗等疾病。
        不过，粘液瘤很很容易通过手术治疗，预后也非常好。
      </p>
      <h4>②血管性肉瘤及横纹肌肉瘤：恶性</h4>
      <p>
        这两种肿瘤的<span style="color: #ab1942">恶性程度高、进展快</span
        >，66%～89%的患者就诊时已发生肺、肝、骨及淋巴结转移。
        如果不经手术迅速切除，90%的患者都会在诊断后9-12个月内死亡。
      </p>
      <h3>2、继发性心脏肿瘤</h3>
      <p>
        心脏继发性肿瘤是其他临近器官恶性肿瘤转移的结果。
        黑色素瘤、肺癌、肾癌、绒毛膜癌、乳腺癌等癌细胞有可能随着血液转移至心脏中，其中<span
          style="color: #ab1942"
          >以黑色素瘤最为常见，约占心脏转移瘤的50-70%</span
        >。 注意：当癌症转移到心脏时，患者预后通常都较差，存活率往往比较低。
      </p>
      <h3>3、心脏出现肿瘤，症状不明显</h3>
      <p>①呼吸困难，心悸、气短，心脏周围出现区域性疼痛。</p>
      <p>②易疲劳胸闷，并伴随恶心、发烧、体重减轻、盗汗等一系列非特异性症状。</p>
      <p>
        这些症状和其他心脏疾病引发的症状类似，因此，给心脏肿瘤的有效诊断带来了困难。
        但还是要提醒大家一旦出现心脏不适，<span style="color: #ab1942"
          >最好立即去医院做个心脏彩超，辅以CT或磁共振成像扫描技术</span
        >。
      </p>
      <h2 style="color: #3158ba">2、为什么心脏患癌率那么低？</h2>
      <h3>1、心肌细胞很少增殖分裂</h3>
      <p>
        从癌症的发病原理上来说，恶性肿瘤是遗传物质DNA“遗传错误”的结果，包括DNA在复制、转录时出现错误。
        也就是说，<span style="color: #ab1942"
          >癌症通常出现在代谢和分裂活跃的细胞里</span
        >。而心脏中最重要的是心肌细胞，这是一种“终末分化细胞”。即从人出生到去世，很少进行增殖分裂，因此它含有的基因基本没有突变出错的机会，这就保证了心脏很少患癌。
      </p>
      <h3>2、心脏中没有上皮细胞</h3>
      <p>
        <span style="color: #ab1942">基因突变尤其偏爱上皮组织</span
        >，所以凡是含有上皮组织的器官都有患癌风险，如肝脏、肾脏、消化道、呼吸道、乳腺、前列腺等等。
        而没有上皮组织的器官，往往长肿瘤几率低，心脏恰恰就没有上皮组织。
      </p>
      <h3>3、与心脏功能有关</h3>
      <p>
        心脏需要不分昼夜的跳动。
        而癌细胞的转移需要在身体某个地方“安营扎寨”，但心脏中的血流速度太快了，绝大多数癌细胞没机会“落地生根”就被血液带走了。
      </p>
      <h3>4、心脏与血管，构成封闭的血液循环系统</h3>
      <p>
        心脏和血管构成了一个<span style="color: #ab1942"
          >独特的密闭循环系统</span
        >，不容易受外来有害物质的入侵干扰，尤其是致癌物质。
        再加上，心脏深藏在机体核心位置，进入到血液的有害物质会经过肝脏、脾脏、肾脏，得到不断的净化处理，减少对心脏的伤害。
      </p>
      <h2 style="color: #3158ba">3、心脏最“怕”这些</h2>
      <p>
        心脏发生癌症的比例低，但心脏病的风险却很高，目前心血管疾病已经超越癌症成为“头号杀手”。
        而下面就是心脏最怕你做的事情：
      </p>
      <h3>1、怕你长胖</h3>
      <p>
        肥胖，一方面，会<span style="color: #ab1942">加重心脏的负担</span
        >，增加血栓、动脉粥样硬化的风险，进而导致冠心病、心肌梗死等；另一方面，脂肪会浸润性侵袭心脏，破坏心脏组织与功能。
        研究表明：体重增加10%，冠心病危险增加38%；体重增加20%，冠心病危险增加86%！
        所以，将体重指数控制（BMI）在18.5~24.9之间更好。
      </p>
      <h3>2、怕累</h3>
      <p>
        生活中“过劳死”的例子不在少数。<span style="color: #ab1942"
          >劳累，会伤害心脏，容易诱发心肌梗死，更可能导致心脏衰竭</span
        >。
        人在过度劳累时，身体会分泌大量的肾上腺素和去甲状腺素等，可使血管痉挛，血压升高，心脏局部血液供应量减少，易诱发心血管疾病。
        所以，不管是工作还是学习，一定要注意劳逸结合，保证充足的睡眠，少熬夜。
      </p>
      <h3>3、怕太激动</h3>
      <p>
        激动时，会使人体内肾上腺激素的分泌发生变化，从而导致心脏跳动过速，增加心脏负担。
        如果患者本身就合并有高血压、动脉硬化等疾病，<span style="color: #ab1942"
          >情绪激动更容易导致血管破裂，发生脑出血甚至猝死</span
        >。 所以，平时要管理好自己的情绪，保持心态平和。
      </p>
      <h3>4、怕高盐</h3>
      <p>
        盐的主要成分是氯化钠，如果钠摄取过多，会造成体内水钠滞留，血管内压力升高，阻力增大，加重心脏负担。
        研究发现，每天摄入盐分超过13.7克的人，患心衰的概率是是那些每天摄入不超过6.8g的人的1倍。
        所以<span style="color: #ab1942"
          >每天盐摄入量不超过6g（大概1个矿泉水瓶盖的量）</span
        >。
      </p>
    </div>
    <div
      v-if="id == 2 && type == 3"
      style="padding: 20px 0; width: 1200px; margin: 0 auto"
    >
      <div
        style="
          margin-top: 40px;
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          line-height: 34px;
        "
      >
        {{ `万万没想到！高血压的"罪魁祸首"不是盐，竟是它…很多人都忽略了` }}
      </div>
      <div
        style="
          margin: 20px auto;
          width: 300px;
          font-size: 12px;
          color: #999;
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <span>{{ "2021-05-25" }}</span>
        <div style="display: flex; align-items: baseline">
          <i class="el-icon-view"></i>
          <span>{{ "57" }}</span>
        </div>
      </div>
      <p>
        大家都知道，食盐摄入过多容易诱发高血压，主要是因为里面的钠离子。但不是说做饭时少放点盐就万事大吉了，还有许多其他食物中也含有较多的钠，它们同样是诱发高血压的元凶。
      </p>
      <h2 style="color: #c13a35">钠从哪里来？</h2>
      <p>
        除了食盐外，我们吃的腌菜、肉制品、休闲食品、豆制品、蔬菜、水果等食物中也含有一定量的”钠”。所以即使我们每天摄入”钠”量等于食用盐中的“钠”量，我们还会从其它的食物中摄入钠。
      </p>
      <p>
        我们每天吃的盐含钠量5克，但实际上，我们摄入”钠”的含量还是超过了5克。所以现在高血压的患病率迟迟没有降下来。
      </p>
      <h2 style="color: #c13a35">钠含量高的食物清单</h2>
      <p>除了食盐之外，纳含量高的食物有：</p>
      <p>
        <span style="color: #ab1942">腌制食品：</span>
        都是用盐来制作，钠含量极高。
      </p>
      <p>
        <span style="color: #ab1942">番茄干：</span>
        100g的西红柿干的含钠量高达2095mg。
      </p>
      <p>
        <span style="color: #ab1942">零食：</span>
        100g的椒盐饼干含有1715mg的钠。
      </p>
      <p>
        <span style="color: #ab1942">乳酪：</span>
        100g乳酪的含钠量约1700mg。
      </p>
      <p>
        <span style="color: #ab1942">海蟹：</span>
        一只阿拉斯加的帝王蟹腿，含有1436mg钠。
      </p>
      <p>
        <span style="color: #ab1942">发酵粉、小苏打：</span>
        一汤勺小苏打，含1368mg钠；一茶匙发酵粉，含有530mg钠。
      </p>
      <p>
        <span style="color: #ab1942">汤料包：</span>
        一份5g的汤料，其中的含钠量约为1200mg。
      </p>
      <p>
        <span style="color: #ab1942">香肠、熏肉、咸肉：</span>
        20克牛肉干含钠量为443mg。
      </p>
      <p>
        <span style="color: #ab1942">沙拉酱、酱油：</span>
        一勺酱油的含钠量是335mg。
      </p>
      <p>
        <span style="color: #ab1942">酵母：</span>
        约6g酵母的钠含量，就可以轻松达到216mg。
      </p>
      <h2 style="color: #c13a35">降血压小妙招</h2>
      <p>
        对于大多数高血压患者，除了按时服用药物治疗外，都应该配合以下的非药物治疗的方法，对改善高血压治疗作用很大。
      </p>
      <h3>减体重</h3>
      <p>对于肥胖高血压患者，体重每减5公斤，血压可下降10~20毫米汞柱。</p>
      <h3>多运动</h3>
      <p>如果运动散步半小时以上，血压可降10个毫米汞柱。</p>
      <h3>少吃盐</h3>
      <p>每天少吃盐在6克以下，血压可降5~6毫米汞柱。</p>
      <h3>好心情</h3>
      <p>保持良好心情，不着急不上火，血压可降5~10个毫米汞柱。</p>
      <h2>
        除了以上这几点，还有几句话，对降压非常有帮助！降压，请记住心血管专家的4句话：
      </h2>
      <h2 style="color: #c13a35">1. 管不住自己嘴巴，就管不住自己血压</h2>
      <p>
        和很多疾病一样，高血压也是要忌口的。如果管不住自己嘴巴，就很难控制血压，比如以下4种食物，高血压病人就要少吃！
      </p>
      <p>
        <span style="color: #ab1942">①刺激食物：</span>
        辣椒、咖喱、芥末等辛辣调味料，葱、芥菜等辛香蔬菜以及酒类、咖啡、浓茶、碳酸饮料等。
      </p>
      <p>
        <span style="color: #ab1942">②过咸食物：</span>
        咸菜、咸鱼、腊肠等，腌制食品含盐度较高，很容易导致血压升高！
      </p>
      <p>
        <span style="color: #ab1942">③高热量食物：</span>
        特别是糖类，容易引起血脂升高。
      </p>
      <p>
        <span style="color: #ab1942">④饱和脂肪酸含量极高的肉类：</span>
        比如牛、猪、羊肉，五花肉，肥肉，香肠，腊肠，熏肉等。
      </p>
      <h2 style="color: #c13a35">2. 吸一支烟，血压持续升高15〜30分钟</h2>
      <p>
        吸1支香烟后，我们的心率平均每分钟会增加5～20次，收缩压上升10～25mmHg。而吸2支烟，10分钟后，由于肾上腺素和去甲肾上腺素的分泌增加，会使心跳更快，收缩压和舒张压都会升高。
      </p>
      <h2 style="color: #c13a35">3. 很多人的高血压，都是熬夜熬出来的</h2>
      <p>
        如果晚上睡眠不好，夜间的血压会因为交感神经不能得到较好的休息，甚至因为失眠引发焦虑，进而造成血压上升，容易形成不正常的血压变化规律。而且这种伤害，可不是第二天白天补觉就能补回来的。
      </p>
      <h2 style="color: #c13a35">4. 心理压力增大，血管压力也会骤增</h2>
      <p>
        工作压力比较大、精神比较紧张的情况下，身体会分泌一种叫儿茶酚胺的化学物质，这种化学物质能引起血管收缩，血管收缩就造成排血时阻力加大，而阻力加大，就会引起血压升高。
      </p>
    </div>
    <div
      v-if="id == 3 && type == 3"
      style="padding: 20px 0; width: 1200px; margin: 0 auto"
    >
      <div
        style="
          margin-top: 40px;
          text-align: center;
          font-size: 24px;
          font-weight: 700;
          line-height: 34px;
        "
      >
        {{ `人体最佳运动阶段表：到什么年纪，就做什么运动！` }}
      </div>
      <div
        style="
          margin: 20px auto;
          width: 300px;
          font-size: 12px;
          color: #999;
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      >
        <span>{{ "2021-05-25" }}</span>
        <div style="display: flex; align-items: baseline">
          <i class="el-icon-view"></i>
          <span>{{ "57" }}</span>
        </div>
      </div>
      <p>
        世界卫生组织公布，<span style="color: #4d67f5"
          >懒得运动已经成为全球第四大死亡风险因素。</span
        >
      </p>
      <p>
        但作为一个普通的上班族，每天朝九晚六的生活中，几乎都是在办公室的座椅上度过，运动的时间或许就是奔向公交车站的那几分钟……但是！运动可不是简单的让身体动起来，<span
          style="color: #4d67f5"
          >每个年龄阶段都有“最佳的运动”</span
        >！
      </p>
      <p>
        但要想找到适合自己的训练方法，首先我们需要弄清楚，运动其实有一个金字塔，它根据运动强度区分了<span
          style="color: #4d67f5"
          >五种运动类别</span
        >。
      </p>
      <h2>第一类基础体力活动</h2>
      <p>
        我们平常的爬楼梯、做家务、购物、遛狗等都算是第一类。这一类运动强度适中，所以每天都可以进行，达到<span
          style="color: #4d67f5"
          >30分钟</span
        >就算是有效的运动了。
      </p>
      <h2>第二类伸展运动</h2>
      <p>
        这一类包括柔软体操、瑜伽、拉伸动作等。做这些运动时，如果你感到身体<span
          style="color: #4d67f5"
          >有拉伸感</span
        >，就是适中的强度。伸展运动可以将每个动作持续30秒左右，每个动作做6~10次即可。
      </p>
      <h2>第三类有氧+休闲运动</h2>
      <p>
        健身的小伙伴肯定会比较熟悉这类运动，它包括游泳、登山、慢跑，球类运动等运动强度中等较大的活动。这类运动可是号称“<span
          style="color: #4d67f5"
          >脂肪的克星</span
        >”！但是需要持续运动20分钟以上，才能达到减脂的效果。
      </p>
      <h2>第四类力量锻炼</h2>
      <p>
        包括半蹲、深蹲、仰卧起坐、平板支撑等，这类运动俗称无氧运动。它的运动强度略微超过我们肌肉的负荷，所以在运动完之后可能会<span
          style="color: #4d67f5"
          >有肌肉酸痛的症状</span
        >，由此这类运动可以促进我们肌肉的生成，是提高我们的基础代谢能力的最佳方式。
      </p>
      <h2>第五类静态活动</h2>
      <p>
        包括坐在办公室、看电视、打游戏，看书等。这类运动的强度是最小的，所以要尽量减少或者缩短静态活动的时长，持续一个小时就要多走动一下，否则会<span
          style="color: #4d67f5"
          >增加患慢性疾病的风险</span
        >。
      </p>
      <p>
        清晰了运动金字塔之后，就来说说，这些运动形式该如何合理安排才能适合不同年龄层的人。
      </p>
      <h2>6-17岁</h2>
      <p>
        这一年龄段的人群，需要重点强化我们身体的<span style="color: #4d67f5"
          >肌肉和骨骼</span
        >部分。
      </p>
      <p>
        因为这是塑造我们形体和骨骼的重要阶段，可以选择以<span
          style="color: #4d67f5"
          >中高强度为主的运动</span
        >，辅助一些力量训练，建议每天运动时间≥60分钟，并且每周至少做3天的高强度运动。
      </p>
      <h3>推荐运动</h3>
      <p>
        慢跑、骑自行车等中等强度运动；跳绳、各种球类、游泳、等高强度运动；攀岩、俯卧撑、仰卧起坐等力量训练。
      </p>
      <h2>18-64岁</h2>
      <p>
        这一阶段的运动强度不变但是需要<span style="color: #4d67f5"
          >逐步增加运动量</span
        >，并且至少保持每周150分钟中强度有氧运动或者75分钟的高强度有氧运动，及2天以上的全身肌肉强化的力量训练。
      </p>
      <h3>推荐运动</h3>
      <p>
        快步走、游泳、交际舞等中等强度运动；跑步、有氧操、快速骑车等高强度运动；弹力带训练、引体向上、仰卧起坐等力量训练。
      </p>
      <h2>65岁以上</h2>
      <p>
        到了65岁之后，就需要<span style="color: #4d67f5"
          >谨慎选择运动的形式</span
        >了，这时候身体或多或少会因为一些慢性疾病，而无法适应同类强度不同形式的运动。
      </p>
      <h3>推荐运动</h3>
      <p>
        步行、跳舞、骑车、慢跑等中强度运动，而力量训练就可以选择哑铃、园艺、瑜伽、太极拳等。
      </p>
      <h2>
        <span style="color: #4d67f5">运动虽好，也不能盲目进行</span
        >，还要提醒大家关于运动的一些注意事项！
      </h2>
      <h3>1、男女运动的区别</h3>
      <p>
        对于女性来说，任何运动都要遵循由简入难，循序渐进的原则，选择适量的运动来塑造美妙的形体，提升身体素质。而不是贪多贪难。尤其在做<span
          style="color: #4d67f5"
          >力量训练</span
        >时更要量力而为，而且一定要在<span style="color: #4d67f5"
          >运动后记得拉伸</span
        >！ 而对于男性来说，需要控制运动的强度，更为重要的一点，就是<span
          style="color: #4d67f5"
          >千万不要在运动过后大量饮酒以及立即吸烟</span
        >！否则会加重心脏和血液循环的负担。
      </p>
      <h3>2、天气运动的区别</h3>
      <p>
        天气寒冷时，首先要做好保暖措施，其次为之后的运动做好热身准备，最后建议大家<span
          style="color: #4d67f5"
          >尽量不要在冬季的早晨进行户外活动</span
        >，冬季的天气状况比较差，反而会不利于我们更好的运动。
        当天气比较炎热时，人的体能消耗会比较大，这时运动很容易造成血糖过低，运动过量的情况，所以还是要建议大家<span
          style="color: #4d67f5"
          >循序渐进</span
        >的运动
      </p>
      <h3>3、不适宜剧烈运动的人群</h3>
      <p>
        对于有些人来说，运动反而是百害而无一利的，这其中就包括患有心脏病、呼吸系统疾病、骨骼硬化、严重贫血、脑部疾病，耳部疾病，肺部疾病，癫痫等人群。
        因为运动过强会导致<span style="color: #4d67f5">过高的心率</span
        >，也就无法及时为身体提供足够的能量，所以以上人群一定要格外小心！
      </p>
      <h3>4、其它运动注意事项</h3>
      <p>
        <span style="color: #4d67f5">不能在过饱状态时去运动</span>，最好在<span
          style="color: #4d67f5"
          >饭后2小时</span
        >之后再运动。在运动之前，要进行充分的热身准备，而不是直接进入运动状态，否则很容易发生肌肉拉伤和受伤的情况。
        而运动结束之后，也要留出时间来进行充分的拉伸。同时在运动结束之后不要暴饮止渴，要<span
          style="color: #4d67f5"
          >少量多次</span
        >摄入，然后再慢慢的停止运动，当心率恢复正常一段时间再去洗浴休息。
      </p>
    </div>
    <div
      style="
        padding: 20px 0;
        background-color: rgb(238, 238, 238);
        text-align: center;
        font-size: 14px;
        line-height: 20px;
        color: #434a54;
      "
    >
      版权所有： 天津市正心大药房连锁有限公司
    </div>
    <div
      style="
        padding: 20px 0;
        text-align: center;
        font-size: 12px;
        line-height: 20px;
        color: rgb(152, 152, 152);
      "
    >
      津ICP备16004233号-1
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imageList: [
        require("@/assets/scroll-image-1.png"),
        require("@/assets/scroll-image-2.png"),
      ],
      id: undefined,
      type: undefined,
      title: "",
      subTitle: "",
    };
  },
  methods: {
    init() {
      let type = Number(this.$route.query.type);
      let id = Number(this.$route.query.id);
      let title = "";
      let subTitle = "";
      switch (type) {
        case 1:
          title = "行业动态";
          if (id === 1) {
            subTitle = "新零售时代来临 医药行业发展趋势";
          } else if (id === 2) {
            subTitle = "连锁药店市场再遇瓶颈 医药电商成为连锁药店救命稻草";
          } else if (id === 3) {
            subTitle = "全国统一医保平台上线 影响39万药店";
          }
          break;
        case 2:
          title = "新闻公告";
          if (id === 1) {
            subTitle =
              "门店功能分区，店面升级改造即，我们将以更好的服务环境和精神面貌为您服务";
          } else if (id === 2) {
            subTitle = "春暖花开养生季 正心优嘉送礼来";
          } else if (id === 3) {
            subTitle = "正心大药房【宝平店】即将盛大开业！";
          } else if (id === 4) {
            subTitle = "杏林仁心宝坻名医--------孙秀兰，坐诊正心大药房";
          }
          break;
        case 3:
          title = "健康中心";
          if (id === 1) {
            subTitle = `人人都说保护心脏，多数人却不知道心脏最"怕"你干这些事`;
          } else if (id === 2) {
            subTitle = `万万没想到！高血压的"罪魁祸首"不是盐，竟是它…很多人都忽略了`;
          } else if (id === 3) {
            subTitle = "人体最佳运动阶段表：到什么年纪，就做什么运动！";
          }
          break;
        default:
          break;
      }
      this.id = id;
      this.type = type;
      this.title = title;
      this.subTitle = subTitle;
    },
  },
  created() {
    this.init();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.menu-item {
  cursor: pointer;
  padding: 20px 30px;
  &:hover {
    color: #27cbee;
    border-bottom: 3px solid #27cbee;
  }
}
</style>
